import React from 'react';
import styles from './Ralsnet.module.scss';

const Ralsnet: React.FC = () => (
  <div className={styles.ralsnet}>
    <a href='https://www.rals.co.jp/' className={styles.ralsnet__logo}>
      <img
        src='https://contents.rals.biz/assets/common/img/rals/img_logo_rals.png'
        alt='株式会社ラルズネット'
        width='200'
      />
    </a>
    <p className={styles.ralsnet__companyname}>株式会社ラルズネット</p>
    <p>Copyright (C) RALSNET Co.,Ltd.All rights reserved.</p>
  </div>
);

export default Ralsnet;
